import React from "react";
import "./Loader.scss";
import { loader } from "../../images";

const Loader = () => {
  return (
    <div className="loader_wrapper">
      <img src={loader} alt="loader gif" className="loader_img" />
    </div>
  );
};

export default Loader;
